import { NavTabs } from "src/components/ui/NavTabs";

import { useAppState } from "src/state";

export function SuperAdminVenueTabs() {

    const { currentItemId } = useAppState(state=>state.tenants)

    return ( 
        <NavTabs
            parentId={currentItemId}
            urlRoot='/venues'
            tabs={{
                details: {
                    label: 'Overview',
                    icon: 'home',
                    route: ''
                },
                bookings: {
                    label: 'Bookings',
                    icon: 'booking',
                    route: 'bookings'
                },
                areas: {
                    label: 'Venue Areas',
                    icon: 'area',
                    route: 'areas'
                },
                guidelines: {
                    label: 'Venue Guidelines',
                    icon: 'guideline',
                    route: 'guidelines'
                },
                users: {
                    label: 'Users',
                    icon: 'agents',
                    route: 'users'
                }
            }}
        />
    )

}